import { render } from "./MarkdownBody.vue?vue&type=template&id=60368af9&scoped=true"
import script from "./MarkdownBody.vue?vue&type=script&lang=js"
export * from "./MarkdownBody.vue?vue&type=script&lang=js"

import "./MarkdownBody.vue?vue&type=style&index=0&id=60368af9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60368af9"]])

export default __exports__